import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData, useLocation } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import Badge from 'react-bootstrap/Badge'
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';


const urlApi = '/categories';
const urlRouter = '/category';

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderCategory(param) {
  let p = {
    'main': true,
    'page': 1,
    'g[0]': 'cat:read',
    'g[1]': 'cat:categories',
    'language': 1
  };
  let res = await AxiosInstance.get(urlApi, { params: { ...p, ...param } }).then((response) => {
    return response;
  });
  return res;
}

const Category = ({ user_data, type }) => {
  if (!Permissions(user_data, 'Category', 'VIEW_CATEGORY')) {
    return <PermissionsNoPage />;
  }
  const location = useLocation();
  const path = location.pathname;

  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextSuccess = "Категорію видалено";

  function getCategoryByPath(page) {
    if (type === 'pages') {
      getRowsTable(page, { "type[0]": "pages", "type[1]": "faq" });
    }
    else if (type === 'projects') {
      getRowsTable(page, { "type[0]": "projects" });
    }
    else if (type === 'products') {
      getRowsTable(page, { "type[0]": "products" });
    }
    else if (type === 'objects') {
      getRowsTable(page, { "type[0]": "objects", "type[1]": "category", "type[2]": "attributes" });
    }
  }

  useEffect(() => {
    // перерендерити якщо змінився урл між категоріями різних типів
    getCategoryByPath(1);
  }, [path])

  if (!rows) {
    setRowCountState(data['hydra:totalItems'] || 0)
    setRows(data['hydra:member']);
  }
  // const getRowsTable = (p = 1, params) => {
  //   // console.log(objects);
  //   AxiosInstance.get(`${urlApi}?main=true&page=${p}&language=1`, { params: params }).then((response) => {
  //     setRows(response.data['hydra:member']);
  //   });
  // };

  const getRowsTable = (p = 1, params = {}) => {
    AxiosInstance.get(urlApi, {
      params: {
        main: true,
        page: p,
        itemsPerPage: 30,
        // itemsPerPage: 2,
        language: 1,
        ...params
      }
    }).then((response) => {
      setRows(response.data['hydra:member']);
      setRowCountState(response.data['hydra:totalItems']);
    });
  };

  const handlePageChange = (page) => {
    getCategoryByPath(page + 1);
  };


  function handleSearch(event) {
    axios.get(process.env.REACT_APP_SERVER_URL + '/api/objects?name=' + event.target.value, header).then((response) => {
      setRows(response.data['hydra:member']);
    });
  }

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
              // Popup про успішні зміни
              popup.toastifySuccess(popupTextSuccess);
              getCategoryByPath(1);
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };


  const Cats = ({ data }) => (
    <>
      {data.categories.map((c) => (
        <Badge key={`cats_${c.id}`} variant="light" className='bg-light text-secondary'>{c.name}</Badge>
      ))}
    </>
  );


  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      disableColumnMenu: true,
      width: 70
    },
    {
      field: 'name',
      headerName: 'Назва',
      width: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'categories', headerName: 'Під категорії', width: 200,
      editable: true,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {

        return (params.row.categories != null && params.row.categories != undefined && params.row.categories.length > 0) &&
          <><Badge variant="light" className='bg-light text-secondary'>{params.row.categories.length}</Badge> <Cats data={params.row} /></>;
      }
    },
    {
      field: 'type',
      headerName: 'Тип',
      sortable: false,
      disableColumnMenu: true,
      width: 200
    },
    {
      field: 'slug',
      headerName: 'Посилання',
      sortable: false,
      disableColumnMenu: true,
      width: 200
    },
    {
      field: 'sort',
      headerName: 'Сортування',
      sortable: false,
      disableColumnMenu: true,
      width: 100
    },
    {
      field: 'created_at',
      headerName: 'Дата',
      type: 'date',
      sortable: false,
      disableColumnMenu: true,
      width: 160,
    },
    {
      field: "action",
      // headerName: "Action",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      // renderCell: (params) => {
      //   return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }

      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/` + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      // headerName: "Видалити",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,

      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => {
      //     Deleted(params.row)
      //   }
      //   }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }

    },
  ];

  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4 mt-4">
            <CCardHeader className='items_card_header'>
              {/* <strong> */}
              {type === 'objects' ? 'Колекціі' : 'Категорії'}
              {/* </strong>  */}
              <small></small>
            </CCardHeader>
            <CCardBody>
              <div className='head_items_wrapper_solo'>
                <p className="text-medium-emphasis small">
                  <Link to={`${urlRouter}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                    {/* Створити */}
                    Add
                  </CButton></Link>
                </p>
              </div>
              <div style={{ height: 600, width: '100%' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={30}
                  rowsPerPageOptions={[30]}
                  // pageSize={2}
                  // itemsPerPage={[2]}
                  pagination
                  rowCount={rowCountState}
                  paginationMode="server"
                  onPageChange={handlePageChange}

                  components={{ Pagination: CustomPagination }}
                  headerHeight={44}
                  getRowClassName={(params) =>
                    selectedIds.includes(params.row.id) ? 'active-row' : ''
                  }

                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #ccc',

                    '& .MuiDataGrid-main': {
                      // borderRadius: '12px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      fontSize: '12px',
                      lineheight: '150%',
                      color: '#717680',
                      //   borderBottom: '2px solid #4e73df',

                    },
                    '& .MuiDataGrid-cell': {
                      fontFamily: 'Inter',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#434349',
                    },
                    '& .MuiDataGrid-footerContainer': {
                      // borderBottomLeftRadius: '12px',
                      // borderBottomRightRadius: '12px',
                    },
                  }}

                />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default Category;